// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
export function applyDisplayName(component, displayName) {
    component.displayName = displayName;
} //# sourceMappingURL=apply-display-name.js.map
